import axios from "axios";
import { decrypt } from "./Crypto";

const handleError = (error) => {
  let err = {
    status: 500,
    message: "Something went wrong, Please try again",
  };
  if (error.response) {
    if (error.response.status !== 500) {
      err = {
        status: error.response.status,
        message:
          error.response.data.message ||
          "Something went wrong, Please try again",
      };
    }
    /* if (err.status === 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            window.location = `${process.env.REACT_APP_PUBLIC_URL}/login`;
        } else if (err.status === 422) {
            err = { ...err, errors: error.response.data.errors };
        } */
  }
  return Promise.reject(err);
};

export const httpAuth = axios.create({
  baseURL: process.env["REACT_APP_API_BASE_URL"],
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: {
      toString() {
        return `${decrypt(localStorage.getItem("tok"))}`;
      },
    },
  },
});

export const httpUnAuth = axios.create({
  baseURL: process.env["REACT_APP_API_BASE_URL"],
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

httpAuth.interceptors.response.use((res) => res, handleError);
httpUnAuth.interceptors.response.use((res) => res, handleError);
